export { default } from './loyalty-incentive-not-available-modal';
